import { createFileRoute, SearchParamError } from '@tanstack/react-router';
import { z } from 'zod';
import { SeoTags } from '#src/components/SeoTags/index.ts';
import { NotFoundPage } from '#src/pages/errorPages/NotFoundPage.tsx';
import { VenuesPage } from '#src/pages/VenuesPage/index.ts';

export const Route = createFileRoute('/{-$locale}/venues')({
  component: RouteComponent,
  errorComponent: ({ error }) => {
    if (error instanceof SearchParamError) {
      return <NotFoundPage />;
    }
    throw error;
  },
  validateSearch: z.object({
    search: z.string().trim().nonempty()
  })
});

function RouteComponent() {
  return (
    <>
      <SeoTags />
      <VenuesPage />
    </>
  );
}
